<app-modal-filler-atom
  (click)="closeComment()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow overflow-y-auto"
  [ngClass]="
    (settingsSelector.selectDeviceIsMobileScreen | async)
      ? 'bottom-0 max-h-85-screen max-w-screen-sm'
      : 'flex justify-center items-center w-full h-full top-0 left-0'
  "
  [style.z-index]="(index$ | async) + 50"
>
  <app-input-comment-atom
    [text]="title"
    [comment]="message"
    (applyComment)="applyComment($event)"
    (closeComment)="closeComment()"
  ></app-input-comment-atom>
</div>
